import React from 'react';
import Grid from '@mui/material/Grid2';
import { EventBus } from '@/shared/utils';
import { Catalog as CatalogDict } from '@/shared/i18n';
import { CatalogEvents } from '../../events';
import { CourseDataFilters } from '../../types/filtered-data';
import { Instrument } from '../../types/instrument';
import { getChildInstruments } from '../../utils/common';
import { FilterContainer } from './filter-container';
import { CreativeCheckbox } from '@/shared/ui';

interface InstrumentsDesktopFilterProps {
  parentInstruments: any[];
  activeFilters: any;
  filters: any;
  instrumentsFilterOnChange: (checked: boolean, instrument: Instrument) => void;
  isEnrichingData?: boolean;
}

export const InstrumentsFilterDesktop: React.FC<InstrumentsDesktopFilterProps> = ({
  parentInstruments,
  activeFilters,
  filters,
  instrumentsFilterOnChange,
}) => {
  return (
    <div>
      <Grid container spacing={{ xs: 1, sm: 2, lg: 3 }}>
        {parentInstruments?.map((instrument, index) => {
          const children = getChildInstruments(instrument, filters.instruments);
          const isParentSelected = activeFilters.instruments.includes(instrument.instrumentName);
          const allChildrenSelected =
            children.length > 0 &&
            children.every((child) => activeFilters.instruments.includes(child.instrumentName));

          return (
            <Grid key={index} size={{ xs: 6, sm: 4, md: 2 }}>
              <CreativeCheckbox
                imageSrc={instrument.icon?.url || ''}
                altText={instrument.instrumentName}
                name={instrument.instrumentName}
                value={instrument.instrumentName}
                checked={isParentSelected || allChildrenSelected}
                onChange={(checked) => instrumentsFilterOnChange(checked, instrument)}
              />
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
};

interface SidebarFilterDesktopProps {
  dict: CatalogDict;
  eventBus: EventBus<CatalogEvents>;
  filters: any;
  activeFilters: CourseDataFilters;
  instrumentsFilterOnChange: (checked: boolean, instrument: Instrument) => void;
  handleSkillLevelsChange: (selectedLevels: string[] | null) => void;
  handleGenresChange: (genre: string, checked: boolean) => void;
  handleTopicsChange: (topic: string, checked: boolean) => void;
  handleTypeChange: (type: string, checked: boolean) => void;
  isEnrichingData?: boolean;
  onResetSidebarFilters: () => void;
  isAnyFilterActive: boolean;
}

export const SidebarFilterDesktop: React.FC<SidebarFilterDesktopProps> = ({
  dict,
  eventBus,
  filters,
  activeFilters,
  instrumentsFilterOnChange,
  handleSkillLevelsChange,
  handleGenresChange,
  handleTopicsChange,
  handleTypeChange,
  isEnrichingData = false,
  onResetSidebarFilters,
  isAnyFilterActive,
}) => {
  return (
    <div className="hidden md:block">
      <FilterContainer
        dict={dict}
        eventBus={eventBus}
        filters={filters}
        activeFilters={activeFilters}
        instrumentsFilterOnChange={instrumentsFilterOnChange}
        handleSkillLevelsChange={handleSkillLevelsChange}
        handleGenresChange={handleGenresChange}
        handleTopicsChange={handleTopicsChange}
        handleTypeChange={handleTypeChange}
        isEnrichingData={isEnrichingData}
        onResetSidebarFilters={onResetSidebarFilters}
        isAnyFilterActive={isAnyFilterActive}
      />
    </div>
  );
};
